module.exports = __webpack_public_path__ + "img/wechat_pay.ff89a587.png";